import React, { useState, useEffect, useCallback, useRef } from 'react';
import GameRanking from '../components/GameRanking'
import PaymentModal from '../components/PaymentModal';
import './CodeInBug.css';

const CELL_SIZE = 30;
const GRID_WIDTH = 19;
const GRID_HEIGHT = 21;
const PREVIEW_LEVELS = 3;

const DIRECTIONS = {
  UP: { x: 0, y: -1 },
  DOWN: { x: 0, y: 1 },
  LEFT: { x: -1, y: 0 },
  RIGHT: { x: 1, y: 0 }
};

const generateMaze = (level) => {
  // Inicializa tudo como parede
  const maze = Array(GRID_HEIGHT).fill(null).map(() => Array(GRID_WIDTH).fill(1));
  
  // PASSO 1: Criar corredor nas bordas (sempre livre para dar a volta)
  // Esta faixa externa SEMPRE está disponível para o jogador circular
  // Borda superior
  for (let x = 0; x < GRID_WIDTH; x++) {
    maze[0][x] = 0;
  }
  // Borda inferior
  for (let x = 0; x < GRID_WIDTH; x++) {
    maze[GRID_HEIGHT - 1][x] = 0;
  }
  // Borda esquerda
  for (let y = 0; y < GRID_HEIGHT; y++) {
    maze[y][0] = 0;
  }
  // Borda direita
  for (let y = 0; y < GRID_HEIGHT; y++) {
    maze[y][GRID_WIDTH - 1] = 0;
  }
  
  // PASSO 2: Criar labirinto interno (área interna que muda a cada nível)
  const carveInternalMaze = (x, y) => {
    maze[y][x] = 0;
    const dirs = [
      [0, -2], [0, 2], [-2, 0], [2, 0]
    ].sort(() => Math.random() - 0.5);
    
    for (let [dx, dy] of dirs) {
      const nx = x + dx;
      const ny = y + dy;
      // Mantém dentro da área interna (não toca nas bordas)
      if (nx > 1 && nx < GRID_WIDTH - 2 && ny > 1 && ny < GRID_HEIGHT - 2 && maze[ny][nx] === 1) {
        maze[y + dy/2][x + dx/2] = 0;
        carveInternalMaze(nx, ny);
      }
    }
  };
  
  // Começa a escavar do centro da área interna
  const startX = 2 + Math.floor(Math.random() * (GRID_WIDTH - 4));
  const startY = 2 + Math.floor(Math.random() * (GRID_HEIGHT - 4));
  carveInternalMaze(startX, startY);
  
  // PASSO 3: GARANTIR aberturas em TODOS os 4 lados (pelo menos 1 por lado)
  // Com caminho garantido até o interior
  
  // Top - Entrada garantida com caminho
  let topX = 2 + Math.floor(Math.random() * (GRID_WIDTH - 4));
  maze[1][topX] = 0;
  // Garante caminho de pelo menos 2 células para dentro
  if (maze[2][topX] === 1) maze[2][topX] = 0;
  
  // Bottom - Entrada garantida com caminho
  let bottomX = 2 + Math.floor(Math.random() * (GRID_WIDTH - 4));
  maze[GRID_HEIGHT - 2][bottomX] = 0;
  // Garante caminho de pelo menos 2 células para dentro
  if (maze[GRID_HEIGHT - 3][bottomX] === 1) maze[GRID_HEIGHT - 3][bottomX] = 0;
  
  // Left - Entrada garantida com caminho
  let leftY = 2 + Math.floor(Math.random() * (GRID_HEIGHT - 4));
  maze[leftY][1] = 0;
  // Garante caminho de pelo menos 2 células para dentro
  if (maze[leftY][2] === 1) maze[leftY][2] = 0;
  
  // Right - Entrada garantida com caminho
  let rightY = 2 + Math.floor(Math.random() * (GRID_HEIGHT - 4));
  maze[rightY][GRID_WIDTH - 2] = 0;
  // Garante caminho de pelo menos 2 células para dentro
  if (maze[rightY][GRID_WIDTH - 3] === 1) maze[rightY][GRID_WIDTH - 3] = 0;
  
  // PASSO 4: Adicionar aberturas extras baseadas no nível (com caminhos garantidos)
  const extraOpenings = Math.floor(level / 2);
  for (let i = 0; i < extraOpenings; i++) {
    const side = Math.floor(Math.random() * 4);
    
    if (side === 0) { // Top extra
      const x = 2 + Math.floor(Math.random() * (GRID_WIDTH - 4));
      maze[1][x] = 0;
      if (maze[2][x] === 1) maze[2][x] = 0;
    } else if (side === 1) { // Right extra
      const y = 2 + Math.floor(Math.random() * (GRID_HEIGHT - 4));
      maze[y][GRID_WIDTH - 2] = 0;
      if (maze[y][GRID_WIDTH - 3] === 1) maze[y][GRID_WIDTH - 3] = 0;
    } else if (side === 2) { // Bottom extra
      const x = 2 + Math.floor(Math.random() * (GRID_WIDTH - 4));
      maze[GRID_HEIGHT - 2][x] = 0;
      if (maze[GRID_HEIGHT - 3][x] === 1) maze[GRID_HEIGHT - 3][x] = 0;
    } else { // Left extra
      const y = 2 + Math.floor(Math.random() * (GRID_HEIGHT - 4));
      maze[y][1] = 0;
      if (maze[y][2] === 1) maze[y][2] = 0;
    }
  }
  
  // PASSO 5: Adicionar bugs (erros) ❌ - SÓ no corredor externo e caminhos internos
  for (let y = 1; y < GRID_HEIGHT - 1; y++) {
    for (let x = 1; x < GRID_WIDTH - 1; x++) {
      if (maze[y][x] === 0 && Math.random() > 0.75) {
        maze[y][x] = 2; // bugs (errors)
      }
    }
  }
  
  // PASSO 5: Adicionar inimigos (;)
  const enemyCount = Math.min(3 + level, 7);
  let enemiesPlaced = 0;
  while (enemiesPlaced < enemyCount) {
    const x = Math.floor(Math.random() * (GRID_WIDTH - 2)) + 1;
    const y = Math.floor(Math.random() * (GRID_HEIGHT - 2)) + 1;
    if (maze[y][x] === 0 && !(x === 1 && y === 1)) {
      maze[y][x] = 3; // semicolon enemies
      enemiesPlaced++;
    }
  }
  
  // PASSO 6: Adicionar power-ups (🤖)
  const powerUpCount = 2 + Math.floor(level / 3);
  let powerUpsPlaced = 0;
  while (powerUpsPlaced < powerUpCount) {
    const x = Math.floor(Math.random() * (GRID_WIDTH - 2)) + 1;
    const y = Math.floor(Math.random() * (GRID_HEIGHT - 2)) + 1;
    if (maze[y][x] === 0 && !(x === 1 && y === 1)) {
      maze[y][x] = 4; // AI power-up
      powerUpsPlaced++;
    }
  }
  
  // PASSO 7: Porta de saída (sempre no canto direito inferior do corredor)
  maze[GRID_HEIGHT - 1][GRID_WIDTH - 2] = 5; // exit
  
  return maze;
};

const CodeInBug = ({ user, onBackToMenu, userProgress }) => {
  const canvasRef = useRef(null);
  const requestRef = useRef();
  const lastTimeRef = useRef(0);
  
  const [gameState, setGameState] = useState('menu');
  const [level, setLevel] = useState(1);
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [maze, setMaze] = useState([]);
  const [player, setPlayer] = useState({ x: 1, y: 1 });
  const [direction, setDirection] = useState(DIRECTIONS.RIGHT);
  const [nextDirection, setNextDirection] = useState(DIRECTIONS.RIGHT);
  const [enemies, setEnemies] = useState([]);
  const [powerMode, setPowerMode] = useState(false);
  const [powerTimer, setPowerTimer] = useState(0);
  const [bugsRemaining, setBugsRemaining] = useState(0);
  const [showTrialModal, setShowTrialModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [enemyMoveCounter, setEnemyMoveCounter] = useState(0);
  const hasAccess = userProgress?.unlockedGames?.includes('codeinbug') || false;

  const initGame = useCallback(() => {
    const newMaze = generateMaze(level);
    setMaze(newMaze);
    setPlayer({ x: 1, y: 0 }); // Começa no corredor superior esquerdo
    setDirection(DIRECTIONS.RIGHT);
    setNextDirection(DIRECTIONS.RIGHT);
    
    const newEnemies = [];
    for (let y = 0; y < GRID_HEIGHT; y++) {
      for (let x = 0; x < GRID_WIDTH; x++) {
        if (newMaze[y][x] === 3) {
          newEnemies.push({
            x, y,
            direction: [DIRECTIONS.UP, DIRECTIONS.DOWN, DIRECTIONS.LEFT, DIRECTIONS.RIGHT][Math.floor(Math.random() * 4)]
          });
        }
      }
    }
    setEnemies(newEnemies);
    
    let bugs = 0;
    for (let y = 0; y < GRID_HEIGHT; y++) {
      for (let x = 0; x < GRID_WIDTH; x++) {
        if (newMaze[y][x] === 2) bugs++;
      }
    }
    setBugsRemaining(bugs);
    
    setGameState('playing');
  }, [level]);

  const startGame = () => {
    if (!hasAccess && level > PREVIEW_LEVELS) {
      setShowTrialModal(true);
      return;
    }
    setScore(0);
    setLives(3);
    setLevel(1);
    initGame();
  };

  const nextLevel = useCallback(() => {
    const newLevel = level + 1;
    
    if (!hasAccess && newLevel > PREVIEW_LEVELS) {
      setShowTrialModal(true);
      setGameState('menu');
      return;
    }
    
    setLevel(newLevel);
    setPowerMode(false);
    setPowerTimer(0);
  }, [level, hasAccess]);

  useEffect(() => {
    if (level > 1) {
      initGame();
    }
  }, [level, initGame]);

  const canMove = (x, y) => {
    if (x < 0 || x >= GRID_WIDTH || y < 0 || y >= GRID_HEIGHT) return false;
    return maze[y][x] !== 1;
  };

  const gameLoop = useCallback((timestamp) => {
    if (gameState !== 'playing') return;
    
    const deltaTime = timestamp - lastTimeRef.current;
    const speed = 150;
    
    if (deltaTime < speed) {
      requestRef.current = requestAnimationFrame(gameLoop);
      return;
    }
    
    lastTimeRef.current = timestamp;

    setPlayer(prev => {
      let newDir = direction;
      const nextX = prev.x + nextDirection.x;
      const nextY = prev.y + nextDirection.y;
      
      if (canMove(nextX, nextY)) {
        newDir = nextDirection;
      }
      
      const newX = prev.x + newDir.x;
      const newY = prev.y + newDir.y;
      
      if (!canMove(newX, newY)) {
        return prev;
      }
      
      setDirection(newDir);
      return { x: newX, y: newY };
    });

    // Inimigos se movem mais devagar (a cada 2 movimentos do jogador)
    setEnemyMoveCounter(prev => {
      const newCounter = prev + 1;
      if (newCounter >= 2) {
        setEnemies(prevEnemies => prevEnemies.map(enemy => {
          const possibleDirs = [DIRECTIONS.UP, DIRECTIONS.DOWN, DIRECTIONS.LEFT, DIRECTIONS.RIGHT]
            .filter(dir => canMove(enemy.x + dir.x, enemy.y + dir.y));
          
          if (possibleDirs.length === 0) return enemy;
          
          let newDir = enemy.direction;
          if (Math.random() > 0.7 || !canMove(enemy.x + newDir.x, enemy.y + newDir.y)) {
            newDir = possibleDirs[Math.floor(Math.random() * possibleDirs.length)];
          }
          
          return {
            x: enemy.x + newDir.x,
            y: enemy.y + newDir.y,
            direction: newDir
          };
        }));
        return 0;
      }
      return newCounter;
    });

    if (powerMode) {
      setPowerTimer(prev => {
        if (prev <= 0) {
          setPowerMode(false);
          return 0;
        }
        return prev - deltaTime;
      });
    }

    requestRef.current = requestAnimationFrame(gameLoop);
  }, [gameState, direction, nextDirection, maze, powerMode, canMove]);

  useEffect(() => {
    requestRef.current = requestAnimationFrame(gameLoop);
    return () => cancelAnimationFrame(requestRef.current);
  }, [gameLoop]);

  useEffect(() => {
    if (gameState !== 'playing') return;

    const cell = maze[player.y]?.[player.x];
    
    if (cell === 2) {
      const newMaze = [...maze];
      newMaze[player.y][player.x] = 0;
      setMaze(newMaze);
      setScore(prev => prev + 10);
      setBugsRemaining(prev => prev - 1);
    } else if (cell === 4) {
      const newMaze = [...maze];
      newMaze[player.y][player.x] = 0;
      setMaze(newMaze);
      setPowerMode(true);
      setPowerTimer(7000);
      setScore(prev => prev + 50);
    } else if (cell === 5 && bugsRemaining === 0) {
      setScore(prev => prev + 200);
      nextLevel();
      return;
    }

    const hitEnemy = enemies.findIndex(e => e.x === player.x && e.y === player.y);
    if (hitEnemy !== -1) {
      if (powerMode) {
        setEnemies(prev => prev.filter((_, i) => i !== hitEnemy));
        setScore(prev => prev + 100);
      } else {
        setLives(prev => {
          const newLives = prev - 1;
          if (newLives <= 0) {
            setGameState('gameover');
          } else {
            setPlayer({ x: 1, y: 0 }); // Reinicia no corredor superior esquerdo
          }
          return newLives;
        });
      }
    }
  }, [player, maze, enemies, powerMode, bugsRemaining, gameState, nextLevel]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (gameState !== 'playing') return;
      
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault();
          setNextDirection(DIRECTIONS.UP);
          break;
        case 'ArrowDown':
          e.preventDefault();
          setNextDirection(DIRECTIONS.DOWN);
          break;
        case 'ArrowLeft':
          e.preventDefault();
          setNextDirection(DIRECTIONS.LEFT);
          break;
        case 'ArrowRight':
          e.preventDefault();
          setNextDirection(DIRECTIONS.RIGHT);
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [gameState]);

  // Touch controls para mobile
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || gameState !== 'playing') return;

    let touchStartX = 0;
    let touchStartY = 0;

    const handleTouchStart = (e) => {
      const touch = e.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    };

    const handleTouchEnd = (e) => {
      const touch = e.changedTouches[0];
      const touchEndX = touch.clientX;
      const touchEndY = touch.clientY;

      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      const minSwipeDistance = 30;

      if (absDeltaX < minSwipeDistance && absDeltaY < minSwipeDistance) {
        return;
      }

      if (absDeltaX > absDeltaY) {
        if (deltaX > 0) {
          setNextDirection(DIRECTIONS.RIGHT);
        } else {
          setNextDirection(DIRECTIONS.LEFT);
        }
      } else {
        if (deltaY > 0) {
          setNextDirection(DIRECTIONS.DOWN);
        } else {
          setNextDirection(DIRECTIONS.UP);
        }
      }
    };

    canvas.addEventListener('touchstart', handleTouchStart);
    canvas.addEventListener('touchend', handleTouchEnd);

    return () => {
      canvas.removeEventListener('touchstart', handleTouchStart);
      canvas.removeEventListener('touchend', handleTouchEnd);
    };
  }, [gameState]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || gameState !== 'playing') return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let y = 0; y < GRID_HEIGHT; y++) {
      for (let x = 0; x < GRID_WIDTH; x++) {
        const cell = maze[y]?.[x];
        
        if (cell === 1) {
          ctx.fillStyle = '#1a1a2e';
          ctx.fillRect(x * CELL_SIZE, y * CELL_SIZE, CELL_SIZE, CELL_SIZE);
          ctx.strokeStyle = '#16213e';
          ctx.strokeRect(x * CELL_SIZE, y * CELL_SIZE, CELL_SIZE, CELL_SIZE);
        } else if (cell === 2) {
          ctx.fillStyle = '#ff0000';
          ctx.font = '18px monospace';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('❌', x * CELL_SIZE + CELL_SIZE/2, y * CELL_SIZE + CELL_SIZE/2);
        } else if (cell === 4) {
          ctx.fillStyle = '#00ff00';
          ctx.font = '20px monospace';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('🤖', x * CELL_SIZE + CELL_SIZE/2, y * CELL_SIZE + CELL_SIZE/2);
        } else if (cell === 5) {
          ctx.fillStyle = bugsRemaining === 0 ? '#00ff00' : '#666666';
          ctx.font = '20px monospace';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('🚪', x * CELL_SIZE + CELL_SIZE/2, y * CELL_SIZE + CELL_SIZE/2);
        }
      }
    }

    enemies.forEach(enemy => {
      ctx.fillStyle = powerMode ? '#0099ff' : '#ffff00';
      ctx.font = '22px monospace';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(';', enemy.x * CELL_SIZE + CELL_SIZE/2, enemy.y * CELL_SIZE + CELL_SIZE/2);
    });

    // Destaque no personagem - círculo brilhante
    ctx.save();
    const playerCenterX = player.x * CELL_SIZE + CELL_SIZE/2;
    const playerCenterY = player.y * CELL_SIZE + CELL_SIZE/2;
    
    // Círculo externo brilhante
    const gradient = ctx.createRadialGradient(playerCenterX, playerCenterY, 0, playerCenterX, playerCenterY, CELL_SIZE/2);
    if (powerMode) {
      gradient.addColorStop(0, 'rgba(255, 255, 0, 0.4)');
      gradient.addColorStop(0.7, 'rgba(255, 255, 0, 0.2)');
      gradient.addColorStop(1, 'rgba(255, 255, 0, 0)');
    } else {
      gradient.addColorStop(0, 'rgba(255, 107, 53, 0.4)');
      gradient.addColorStop(0.7, 'rgba(255, 107, 53, 0.2)');
      gradient.addColorStop(1, 'rgba(255, 107, 53, 0)');
    }
    ctx.fillStyle = gradient;
    ctx.fillRect(player.x * CELL_SIZE, player.y * CELL_SIZE, CELL_SIZE, CELL_SIZE);
    
    // Borda do personagem
    ctx.strokeStyle = powerMode ? '#ffff00' : '#ff6b35';
    ctx.lineWidth = 3;
    ctx.strokeRect(player.x * CELL_SIZE + 2, player.y * CELL_SIZE + 2, CELL_SIZE - 4, CELL_SIZE - 4);
    ctx.restore();

    // Personagem (café) com rotação
    ctx.save();
    ctx.translate(player.x * CELL_SIZE + CELL_SIZE/2, player.y * CELL_SIZE + CELL_SIZE/2);
    if (direction === DIRECTIONS.LEFT) ctx.rotate(Math.PI);
    else if (direction === DIRECTIONS.UP) ctx.rotate(-Math.PI/2);
    else if (direction === DIRECTIONS.DOWN) ctx.rotate(Math.PI/2);
    
    ctx.fillStyle = powerMode ? '#ffff00' : '#ff6b35';
    ctx.font = '24px monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('☕', 0, 0);
    ctx.restore();

  }, [gameState, maze, player, enemies, direction, powerMode, bugsRemaining]);

  const handleUnlock = () => {
    setShowTrialModal(false);
    setShowPaymentModal(true);
  };

  if (gameState === 'menu') {
    return (
      <div className="codeinbug-container">
        <div className="codeinbug-menu">
          <h1 className="codeinbug-title">
            <span className="code-bracket">{'<'}</span>
            Code In Bug
            <span className="code-bracket">{'/>'}</span>
          </h1>
          <p className="codeinbug-subtitle">Corrija os bugs do labirinto!</p>
          <div className="codeinbug-instructions">
            <p>☕ Use as setas ou gestos para mover</p>
            <p>❌ Colete todos os bugs</p>
            <p>🤖 Use a IA para comer os ;</p>
            <p>🚪 Saia pela porta quando limpar tudo</p>
          </div>
          <button className="codeinbug-button" onClick={startGame}>
            Iniciar Jogo
          </button>
          <button className="codeinbug-button secondary" onClick={onBackToMenu}>
            Voltar ao Menu
          </button>
        </div>
      </div>
    );
  }

  if (gameState === 'gameover') {
    return (
      <div className="codeinbug-container">
        <div className="codeinbug-menu">
          <h1 className="codeinbug-title game-over">GAME OVER</h1>
          <p className="codeinbug-score">Pontuação Final: {score}</p>
          <p className="codeinbug-level">Nível Alcançado: {level}</p>
          <button className="codeinbug-button" onClick={startGame}>
            Jogar Novamente
          </button>
          <button className="codeinbug-button secondary" onClick={onBackToMenu}>
            Voltar ao Menu
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="codeinbug-container">
      <div className="codeinbug-hud">
        <div className="hud-item">
          <span>SCORE: {score}</span>
        </div>
        <div className="hud-item">
          <span>LEVEL: {level}</span>
        </div>
        <div className="hud-item">
          <span>LIVES: {'❤️'.repeat(lives)}</span>
        </div>
        <div className="hud-item">
          <span>BUGS: {bugsRemaining}</span>
        </div>
        {powerMode && (
          <div className="hud-item power">
            <span>🤖 POWER: {Math.ceil(powerTimer/1000)}s</span>
          </div>
        )}
        <button className="codeinbug-button back-btn" onClick={onBackToMenu}>
          ← Menu
        </button>
      </div>
      
      <canvas 
        ref={canvasRef}
        width={GRID_WIDTH * CELL_SIZE}
        height={GRID_HEIGHT * CELL_SIZE}
        className="codeinbug-canvas"
      />

      {showTrialModal && (
        <div className="trial-modal-overlay">
          <div className="trial-modal">
            <h2>🎮 Versão de Teste</h2>
            <p>Você jogou as {PREVIEW_LEVELS} fases de demonstração!</p>
            <p>Desbloqueie o jogo completo para continuar.</p>
            <div className="trial-modal-buttons">
              <button onClick={handleUnlock} className="unlock-button">
                Desbloquear Agora
              </button>
              <button onClick={() => { setShowTrialModal(false); onBackToMenu(); }} className="back-button">
                Voltar ao Menu
              </button>
            </div>
          </div>
        </div>
      )}

      <PaymentModal
        show={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onPaymentComplete={(paymentData) => {
          console.log('Payment complete:', paymentData);
          setShowPaymentModal(false);
          // Recarrega o jogo para desbloquear
          if (onBackToMenu) {
            onBackToMenu();
          }
        }}
        gameToUnlock="codeinbug"
        userProgress={userProgress}
        user={user}
      />
    </div>
  );
};

export default CodeInBug;
